import OutsideClickHandler from 'react-outside-click-handler';
import React from 'react';
import classNames from 'classnames';

import NumberInput from 'fantastic/components/common/NumberInput';
import utils from 'fantastic/lib/utils';

const Size = (props) => {
  const { min = 0, max = 100 } = props;
  const size = props.size.value || '';

  const onChange = (value) => {
    const { onChange, size: { field } } = props;
    onChange(field, parseInt(value).toString());
  };

  return (
    <div className="btn-group">
      <NumberInput value={size} onChange={onChange} max={max} min={min} />
    </div>
  );
};

export default Size;
